import './env'

// Needed for redux-saga es6 generator support
// import 'babel-polyfill'

// Import all the third party stuff
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import initSentry from './utils/sentry'

// Import CSS reset and Global Styles
// NOTE: GlobalStyle はこの位置から動かさないこと。
// App より先にマウントしないとグローバルスタイルが上書きされる。
import GlobalStyle from './global-styles'
import './fonts.css'
import './vars/tokens.css'

// Import root app
import App from 'containers/App'

/* eslint-enable import/no-unresolved, import/extensions */

import { store } from './reduxStoreHelper'

import '@fortawesome/fontawesome-free/css/all.css'

import moment from 'moment'
import 'moment/locale/ja'

moment.locale('ja')

// Sentry初期化
initSentry()

const root = createRoot(document.getElementById('root')!)

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <GlobalStyle />
      <App />
    </BrowserRouter>
  </Provider>
)
